import { Component, Input, Output, EventEmitter } from '@angular/core';
import { StepsService } from '../../../services/steps.service';
import { IChangePasswordRequest } from '../../../classes/change-password';
import { IInitializePasswordRequest } from '../../../classes/initialize-password';

@Component({
	selector: 'change-password-container',
	template: require('./change-password-container.component.html'),
})
export class ChangePasswordContainerComponent {
	@Output() EmitIsValidForm = new EventEmitter();
	@Input() changePassRequest: IChangePasswordRequest;
	@Input() initRequest: IInitializePasswordRequest;
	@Input() userId: string;

	@Input() isNewChangePasswordModals: boolean = false;
	constructor(public stepsService: StepsService) {}

	isValidForm(event: any): void {
		this.EmitIsValidForm.emit(event);
	}
}
